/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type accessBlocked_viewer$ref = any;
export type accessBlocked_QueryVariables = {||};
export type accessBlocked_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: accessBlocked_viewer$ref,
  |}
|};
export type accessBlocked_Query = {|
  variables: accessBlocked_QueryVariables,
  response: accessBlocked_QueryResponse,
|};
*/


/*
query accessBlocked_Query {
  viewer {
    actualPersonId
    component(name: "access_blocked")
    ...accessBlocked_viewer
    id
  }
}

fragment accessBlocked_viewer on Viewer {
  id
  company {
    id
    accessBlocked
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "access_blocked"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"access_blocked\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accessBlocked_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accessBlocked_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accessBlocked_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessBlocked",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "accessBlocked_Query",
    "operationKind": "query",
    "text": "query accessBlocked_Query {\n  viewer {\n    actualPersonId\n    component(name: \"access_blocked\")\n    ...accessBlocked_viewer\n    id\n  }\n}\n\nfragment accessBlocked_viewer on Viewer {\n  id\n  company {\n    id\n    accessBlocked\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0a3de486ca24ccf47876f50c207a3ffb';

module.exports = node;
